import { create } from 'zustand';
import { TranslateSettingState } from './interface';

export const translateSettingState = create<TranslateSettingState>()((set: any) => ({
    setting: {
        lang: '',
        trans_lang: '',
        setup_lang: 'zh-cn', // 字幕语言
        font_size: '3', // 字体大小：1-特小；2-小；3-正常；4-大；5-特大
        original_pos: '1', // 原始语言字幕位置：1-画面下方；2-画面上方
        trans_pos: '1', // 翻译字幕位置：1-画面下方；2-画面上方
        display_original: 0, // 是否同时展示原始语言字幕 0-不展示；1-展示
        apply_to_learner: 0, // 可选，是否应用到学员侧默认设置：0-否；1-是
    },
    setSetting: (value: { [key: string]: any }) => set(() => ({ setting: value })),
}));
